/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsLauncherHubCustomPage interface.
 */
export function instanceOfFxIdDomainSettingsLauncherHubCustomPage(value) {
    return true;
}
export function FxIdDomainSettingsLauncherHubCustomPageFromJSON(json) {
    return FxIdDomainSettingsLauncherHubCustomPageFromJSONTyped(json, false);
}
export function FxIdDomainSettingsLauncherHubCustomPageFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Title': json['Title'] == null ? undefined : json['Title'],
        'Version': json['Version'] == null ? undefined : json['Version'],
        'Url': json['Url'] == null ? undefined : json['Url'],
        'HomePage': json['HomePage'] == null ? undefined : json['HomePage'],
    };
}
export function FxIdDomainSettingsLauncherHubCustomPageToJSON(json) {
    return FxIdDomainSettingsLauncherHubCustomPageToJSONTyped(json, false);
}
export function FxIdDomainSettingsLauncherHubCustomPageToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Title': value['Title'],
        'Version': value['Version'],
        'Url': value['Url'],
        'HomePage': value['HomePage'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsLauncherHubCustomPage.js.map